export {
  APPLICATION_ACTIVITY_HEADING,
  applicationStatusLabel,
  APPLY_FOR_FINANCING_LABEL,
  CANCEL_REPLACE_APPLICATION_LABEL,
  CONFIRM_REPLACE_APPLICATION_LABEL,
  FINANCING_CHANGED_LABEL,
  MARK_APPROVED_CANCEL_LABEL,
  MARK_APPROVED_CONFIRM_LABEL,
  MARK_APPROVED_CONFIRM_PROMPT,
  MARK_APPROVED_LABEL,
  PREVIOUS_APPLICATIONS_HEADING,
  REOPEN_APPLICATION_LABEL,
  REPLACE_APPLICATION_LABEL,
} from "../../ProposalSetup/financing/credit-human-copy"

export const APPLICATION_STATUS_ACTION_LABEL = `Application status`
